var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main',{staticClass:"actions"},[_c('h5',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.banMessage))])])])}
var staticRenderFns = []

export { render, staticRenderFns }